/**
 * Call OpenAI via Firebase Cloud Function REST API
 * @param {string} question - The question to send to OpenAI
 * @param {string} customInstructions - Optional custom instructions to override the default
 * @returns {Promise<string>} - The AI's response text
 */
export const callOpenAI = async (question, customInstructions) => {
  try {
    const instructions =
      customInstructions ||
      "You are an AI assistant for the Hackathon Platform. Guide applicants clearly on registration, teams, mentors, resources, communication, and deadlines.Registration: Deadline is 2nd October. After this, accounts cannot be created. A verification email is sent when registering — remind users to check spam if missing.Teams: To create a team, enter a name and description. The creator becomes the team leader. Leaders can invite users who already have accounts but are not in any team. Leaders can also accept or decline requests from users who want to join. Users without a team can view available teams (with fewer than 5 members) and request to join.Mentorship & Resources: Teams with 3 or more members are assigned a mentor. Mentor resources appear in the Resources tab, and users can mark them as completed to track progress.Communication: Notifications show important updates. In the Teams tab, the Open Chat button allows team members and mentors to communicate. This is the official communication channel.Applications: Joining a team adds 45% to application completion. Applications are open 20th–24th October unless stated otherwise.Support: The Get Support button links to the official WhatsApp support group";

    const response = await fetch(
      "https://api-mvje637liq-uc.a.run.app/generate",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          instructions,
          question,
        }),
      },
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    if (data.success) {
      return data.text;
    } else {
      throw new Error(data.error || "Failed to get response from OpenAI");
    }
  } catch (error) {
    console.error("Error calling OpenAI:", error);
    throw error;
  }
};

/**
 * Example usage in a React component:
 *
 * import { callOpenAI } from '../Services/openai-service';
 *
 * const MyComponent = () => {
 *     const [response, setResponse] = useState('');
 *     const [loading, setLoading] = useState(false);
 *
 *     const handleAsk = async () => {
 *         setLoading(true);
 *         try {
 *             const answer = await callOpenAI(
 *                 "How do I create a team?",
 *                 0.5
 *             );
 *             setResponse(answer);
 *         } catch (error) {
 *             console.error('Error:', error);
 *         } finally {
 *             setLoading(false);
 *         }
 *     };
 *
 *     return (
 *         <div>
 *             <button onClick={handleAsk} disabled={loading}>
 *                 {loading ? 'Loading...' : 'Ask AI'}
 *             </button>
 *             {response && <p>{response}</p>}
 *         </div>
 *     );
 * };
 */
